import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  createParser,
  parseAsStringLiteral,
} from 'nuqs'
import { NotSetAccountOrSalesOwnerFilterId } from 'api/shifts/getAllShifts'
import { CompanyType } from '../components/ShiftListFilters/CompanyFilters/CompanyTypes/constants'

export const parseOwnerIds = createParser({
  parse: (v) => {
    if (v === NotSetAccountOrSalesOwnerFilterId) {
      return NotSetAccountOrSalesOwnerFilterId
    }
    const number = Number(v)

    if (Number.isNaN(number)) {
      return null
    }

    return number
  },
  serialize: (v: string | number) => {
    if (v === NotSetAccountOrSalesOwnerFilterId) {
      return NotSetAccountOrSalesOwnerFilterId
    }
    return String(v)
  },
  eq: (a, b) => a === b,
})

export const companyTypesParser = parseAsArrayOf<CompanyType>(
  parseAsStringLiteral(['1099', 'w2'])
)

export const useCompanyQueryState = () => {
  const queryStates = useQueryStates(
    {
      companyIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      companyGroupIds: parseAsArrayOf(parseAsInteger).withDefault([]),
      salesOwnerIds: parseAsArrayOf(parseOwnerIds).withDefault([]),
      accountOwnerIds: parseAsArrayOf(parseOwnerIds).withDefault([]),
      companyTypes: companyTypesParser.withDefault([]),
    },
    {
      urlKeys: {
        companyIds: 'company-ids',
        companyGroupIds: 'company-group-ids',
        salesOwnerIds: 'sales-owner-ids',
        accountOwnerIds: 'account-owner-ids',
        companyTypes: 'company-types',
      },
    }
  )

  return queryStates
}
